// extracted by mini-css-extract-plugin
module.exports = {"Container":"ToggleSwitch_Container__n6O7i","Checkbox":"ToggleSwitch_Checkbox___w9Gq","Label":"ToggleSwitch_Label___g6g4"};